import {GdspSdsAsset} from '../items/item.class';

export const EXCLUDE_ST_LIMIT = 60;

export class Exceptions {
    bin?: string[];
    canShipAir: boolean;
    excludeStArray?: string[];
    graMsdsavail_b?: boolean;
    gdspSdsAsset?: GdspSdsAsset;
    GSDP_ID_s?: string;
    id: string;
    itemNeedsAppr?: boolean;
    lotTrack?: boolean;
    lottracking?: boolean;
    msdsavail?: boolean;
    ormd: boolean;
    prop65b_b: boolean;
    prop65c_b: boolean;
    prop65Message: string;
    sds_s: string;
    sdsAssetFileName_s: string;
    sdsLink?: string;
    upsHazard: boolean;
}
